import { Badge, Button, Column, MeatballMenu, Row, Text } from "@gradience/ui";
import { IconContainer } from "@gradience/ui/dist/components/icon";
import { useApiQuery } from "../../../../lib/api";
import { useSelectedTest } from "../../../../domain/use-latest-test";
import { displayDateNoYear } from "../../../../lib/display-date";
import { useNavigate } from "@tanstack/react-router";

export const NoCard = () => {
  const selectedTest = useSelectedTest();
  const registration = useApiQuery(
    "/registrations/:testId",
    { testId: selectedTest.data?.id ?? "" },
    { enabled: selectedTest.data?.id !== undefined }
  );
  const school = useApiQuery("/school", {});

  const navigate = useNavigate({
    from: "/",
  });

  if (!registration.data) {
    return null;
  }

  return (
    <Column gap={24}>
      <Row
        gap={16}
        style={{
          alignItems: "flex-start",
        }}
      >
        <IconContainer icon="card-02" />
        <Column style={{ flex: 1 }}>
          <Text textStyle="20px - Bold">Registration</Text>
          <Text textStyle="14px - Medium">
            <Column gap={4} style={{ alignItems: "flex-start" }}>
              <Text textStyle="14px - Medium">
                Add your card to register for the ULE
              </Text>
              {registration.data.earlyRegistrationCutoffDate &&
              new Date() <
                new Date(registration.data.earlyRegistrationCutoffDate) ? (
                <Badge
                  type="warning"
                  icon="information-circle-contained"
                  children={`Register before ${displayDateNoYear(registration.data.earlyRegistrationCutoffDate)} for a discount`}
                />
              ) : null}
            </Column>
          </Text>
        </Column>
      </Row>
      <Button
        text="Add Billing Info"
        leadingIcon="card-02"
        variant="subdued"
        size="medium"
        linkProps={{
          search: {
            modal: "billing-method",
          },
        }}
      />
    </Column>
  );
};
